module.exports = __webpack_public_path__ + "static/media/sticky-footer-loader.241ab3c6.gif";